import React from 'react';
import { MessageCircle } from 'lucide-react';
import { storeInfo } from '../data/mockData';

const FloatingWhatsApp = () => (
  <a
    href={storeInfo.contact.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#c8ff00] rounded-full flex items-center justify-center shadow-lg shadow-[#c8ff00]/20 hover:scale-110 transition-transform duration-200"
    aria-label="Chat on WhatsApp"
  >
    <MessageCircle size={24} className="text-black" />
  </a>
);

export default FloatingWhatsApp;
